<template>
    <div class="page" ref="scroller">
        <div class="queryBox">
            <span class="sub_title">学院干货</span>
            <div class="input-box">
                <form action="" onsubmit="return false">
                    <input
                        v-model="key"
                        type="search"
                        placeholder="请输入文章标题"
                        autocomplete="off"
                        ref="input"
                    />
                </form>
                <img
                    class="search-logo"
                    src="~@/assets/search-logo.png"
                    alt=""
                />
            </div>
            <!-- <van-button
                @click="showSearchArticlePrompt"
                type="default"
                size="small"
            >
                文章搜索
            </van-button> -->

            <div class="sxBox">
                <div class="sxBoxLogo" @click="showQueryBox">
                    <span class="searchAuthorNote">作者搜索</span>
                    <img class="query" src="~@/assets/query.png" alt />
                </div>
                <div class="list" v-show="showQuery">
                    <div class="item" @click="searchArticle('')">全部</div>
                    <div
                        v-for="item of authorList"
                        :key="item.id"
                        @click="searchArticle(item.id)"
                        class="item"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>

        <!-- <van-popup v-model="show">
            <div class="searchPopupBox">
                <div class="key">请输入关键字</div>
                <input v-iosInput type="text" v-model="key" />
                <div class="btns">
                    <div @click="showSearchArticlePrompt()">取消</div>
                    <div @click="searchKey()">确定</div>
                </div>
            </div>
        </van-popup> -->
        <div v-if="total > 0" class="list-len">
            <span>{{ total }}篇相关文章</span>
        </div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="listBox"
        >
            <div
                v-for="item in list"
                :key="item.id"
                class="item"
                @click="goArticleDetail(item.id)"
            >
                <div class="title">{{ item.title }}</div>
                <div class="summary" v-html="item.summary"></div>
                <div class="timeBox">
                    <span class="time">{{ item.pubTime }}</span>
                    <span
                        class="article_type"
                        :class="item.target == 'FREE' ? 'free' : 'pay'"
                        >{{
                            item.target == "FREE"
                                ? "免费阅读"
                                : item.target == "PAY"
                                ? "付费解锁"
                                : item.target == "STUDENT"
                                ? "学员专享"
                                : ""
                        }}</span
                    >
                    <span class="readNum">{{ item.readNum }}人看过</span>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
    import ganhuoService from "../../service/ganhuo.service";
    import scrollerMixin from "../../scroller.mixin";
    export default {
        name: "ganhuo-list",
        mixins: [scrollerMixin],
        data() {
            return {
                loading: false,
                finished: false,
                show: false,
                showQuery: false,
                authorList: [],
                list: [],
                page: 1,
                row: 10,
                authorId: "",
                key: "",
                total: 0,
            };
        },
        mounted() {
            this.getAuthorList();
            // if (this.loading) {
            //     this.onLoad();
            // }

            this.$refs.input.addEventListener("search", (e) => {
                e.preventDefault();
                this.searchKey();
            });
        },
        methods: {
            searchKey() {
                this.list = [];
                this.page = 1;
                this.getData("", this.key);
            },
            getAuthorList() {
                ganhuoService.getAuthorList().then((res) => {
                    this.authorList = res.data;
                });
            },
            showSearchArticlePrompt() {
                this.show = !this.show;
            },
            showQueryBox() {
                this.showQuery = !this.showQuery;
            },
            searchArticle(authorId) {
                this.page = 1;
                this.list = [];
                this.showQuery = false;
                this.getData(authorId);
            },
            getData(authorId, key = "") {
                ganhuoService
                    .getList({
                        page: this.page,
                        row: this.row,
                        authorId,
                        key,
                    })
                    .then((res) => {
                        if (this.authorId != authorId) {
                            this.list = [];
                        }
                        this.authorId = authorId;
                        let total = (this.total = res.data.total);
                        this.list.push(...res.data.list);
                        if (this.list.length <= 0) {
                            this.finished = true;
                        }
                        if (this.list.length >= total) {
                            this.finished = true;
                        }
                        this.page++;
                        this.loading = false;
                        this.showQuery = false;
                        this.show = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            onLoad() {
                this.loading = true;
                this.getData(this.authorId);
            },
            goArticleDetail(id) {
                this.$router.push({ path: `/ganhuo-detail/${id}` });
            },
        },
    };
</script>

<style lang="scss" scoped src="./ganhuo-list.scss"></style>
